import { render, staticRenderFns } from "./CenterBottom.vue?vue&type=template&id=60acbcdf&scoped=true"
import script from "./CenterBottom.vue?vue&type=script&lang=js"
export * from "./CenterBottom.vue?vue&type=script&lang=js"
import style0 from "./CenterBottom.vue?vue&type=style&index=0&id=60acbcdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acbcdf",
  null
  
)

export default component.exports